import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_ESL_EXISTS,
  SOFTLINE_API_ESL_FLASH_LED,
  SOFTLINE_API_ESL_SWITCH_SCENARIO,
} from '../esl.api';
import { EslRequest } from '../types/esl-request';

@Injectable({ providedIn: 'root' })
export class ESLRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  async checkIfEslExists(itemId: number): Promise<any> {
    return await this.dataAccess.create(
      {
        path: SOFTLINE_API_ESL_EXISTS,
        pathParams: {
          itemId,
        },
      },
      {}
    );
  }

  // Makes the labels flash their LED lights at a set duration and color
  async flashEsl(body: EslRequest): Promise<any> {
    return await this.dataAccess.create({ path: SOFTLINE_API_ESL_FLASH_LED }, body);
  }

  // Temporary switch certain labels to the given scenario
  async switchEslScenario(type: string, body: EslRequest): Promise<any> {
    return await this.dataAccess.create(
      { path: SOFTLINE_API_ESL_SWITCH_SCENARIO, pathParams: { type } },
      body
    );
  }
}
